import React from 'react'

function NewCustomerCard({ text, onClick }) {
  return (
    <div
      onClick={onClick}
      className='card border-0 py-4 my-1 mx-2 shadow-sm d-flex justify-content-center align-items-center cursor-pointer'
      style={{ borderRadius: 10 }}>
      <h6 className='mb-0'>{text}</h6>
    </div>
  )
}

export default React.memo(NewCustomerCard)
